<template>
  <div class="row">
    <div class="col-md-12">
      <div style="overflow:auto; max-height: 400px;">
        <ckeditor :editor="editor" v-model="data" :config="ckEditorConfig"></ckeditor>
      </div>
      <button type="button" @click="editDescription" class="btn btn-fill btn-info pull-right">
        Edit Description
      </button>
    </div>
  </div>
</template>

<script>
import CKEditor from '@ckeditor/ckeditor5-vue'
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor'
import ckEditorConfig from 'src/utilities/ckeditor'

export default {
  props: ['data'],
  components: {
    ckeditor: CKEditor.component
  },
  data() {
    return {
      editor: ClassicEditor,
      ckEditorConfig
    }
  },

  methods: {
    editDescription() {
      this.$store.set('supplyPro/job/ptracJob@description', this.data.slice(3, -4))
      // this.$eventHub.$emit('projectNotesUpdated')
      this.$emit('close')
    }
  }
}
</script>